import { FloatButton, Layout } from 'antd';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import classNames from 'classnames';
import { TopBar } from 'src/components/LayoutComponents/TopBar';
import { Footer } from 'src/components/LayoutComponents/Footer';
import React from 'react';

interface MainLayoutProps extends RouteComponentProps {
  children: React.ReactNode;
  isBorderless?: boolean;
  isSquaredBorders?: boolean;
  isFixedWidth?: boolean;
  isMenuShadow?: boolean;
  isMenuTop?: boolean;
}
class MainPageLayout extends React.PureComponent<MainLayoutProps> {
  render() {
    const { children, isBorderless, isSquaredBorders, isFixedWidth, isMenuShadow, isMenuTop } =
      this.props;
    return (
      <Layout
        className={classNames({
          settings__borderLess: isBorderless,
          settings__squaredBorders: isSquaredBorders,
          settings__fixedWidth: isFixedWidth,
          settings__menuShadow: isMenuShadow,
          settings__menuTop: isMenuTop,
        })}
      >
        <FloatButton.BackTop />
        <Layout>
          <Layout.Header>
            <TopBar />
          </Layout.Header>
          <Layout.Content style={{ height: '100%', position: 'relative' }}>
            <div className="utils__content" style={{ maxWidth: 'none' }}>
              {children}
            </div>
          </Layout.Content>
          <Layout.Footer>
            <Footer />
          </Layout.Footer>
        </Layout>
      </Layout>
    );
  }
}

export const MainLayout = withRouter(MainPageLayout);
